import { render, staticRenderFns } from "./SetQualityControlModal.vue?vue&type=template&id=dc7fad5a&"
import script from "./SetQualityControlModal.vue?vue&type=script&lang=js&"
export * from "./SetQualityControlModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports